import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import {
  COMMENT_DEPTH_MARGIN_LEFT,
  COMMENT_HORIZONTAL_PADDING,
  REPLY_DEPTH_MARGIN_LEFT,
} from "app/main/constants";
import { px2rem } from "common/helpers/rem";

const THREAD_FONT_SIZE = 13;
const REPLY_FONT_SIZE = 12;

export const Username = styled(Link)<{ highlight: boolean }>`
  display: inline-block;
  vertical-align: top;
  line-height: ${px2rem(16)};
  font-size: ${px2rem(THREAD_FONT_SIZE)};
  font-weight: bold;
  color: ${props => props.theme.grey1000};
  text-decoration: none;
  ${props =>
    props.highlight &&
    css`
      padding: 0 ${px2rem(8)};
      line-height: ${px2rem(20)};
      border-radius: ${px2rem(18)};
      color: ${props.theme.white100};
      background-color: ${props.theme.grey700};
    `}
`;
Username.displayName = "Username";

export const Content = styled.div`
  padding-right: ${px2rem(COMMENT_HORIZONTAL_PADDING)};
  white-space: pre-line;
  margin: ${px2rem(4)} 0 0;
  font-size: ${px2rem(THREAD_FONT_SIZE)};
  line-height: ${px2rem(18)};
  color: ${props => props.theme.grey1000};
  word-wrap: break-word;
  overflow-wrap: break-word;
`;
Content.displayName = "Content";

export const ThreadItemFooterLeft = styled.span``;
ThreadItemFooterLeft.displayName = "ThreadItemFooterLeft";

export const ThreadItemFooterRight = styled.span`
  vertical-align: top;
  float: right;
`;
ThreadItemFooterRight.displayName = "ThreadItemFooterRight";

export const ThreadItemBody = styled.div``;
ThreadItemBody.displayName = "ThreadItemBody";

export const ThreadItemWrapper = styled.div<{ minimum: boolean }>`
  ${props => {
    const padding = px2rem(props.minimum ? 8 : 16);
    return {
      padding: `${padding} 0 ${padding} ${px2rem(COMMENT_HORIZONTAL_PADDING)}`,
    };
  }};
  position: relative;
  ${ThreadItemBody} {
    margin-left: ${props =>
      px2rem(
        props.minimum ? REPLY_DEPTH_MARGIN_LEFT : COMMENT_DEPTH_MARGIN_LEFT,
      )};
  }
  ${Content}, ${Username} {
    font-size: ${props =>
      px2rem(props.minimum ? REPLY_FONT_SIZE : THREAD_FONT_SIZE)};
  }
  font-weight: ${props => props.theme.weightRegular};
`;
ThreadItemWrapper.displayName = "ThreadItemWrapper";

export const ThreadItemLeft = styled.div`
  vertical-align: top;
  float: left;
`;
ThreadItemLeft.displayName = "ThreadItemLeft";

export const ThreadItemExtra = styled.div``;
ThreadItemExtra.displayName = "ThreadItemExtra";

export const ThreadItemFooter = styled.div`
  height: ${px2rem(16)};
  padding-right: ${px2rem(COMMENT_HORIZONTAL_PADDING)};
  font-size: ${px2rem(11)};
  line-height: 1.3;
  margin-top: ${px2rem(8)};
  color: ${props => props.theme.grey500};
`;
ThreadItemFooter.displayName = "ThreadItemFooter";

export const ThreadItemTitle = styled.div`
  padding-right: ${px2rem(COMMENT_HORIZONTAL_PADDING)};
`;
ThreadItemTitle.displayName = "ThreadItemTitle";
